export default __webpack_public_path__ + "static/media/ic-logo.2ab0a4e8.svg";